/**
 * It returns the date template for displaying dates in a long format.
 *
 * ```javascript
 * import { DATE_TEMPLATE_BY_DAY_LONG } from 'src/core/constants/date.constants';
 *
 * console.log(DATE_TEMPLATE_BY_DAY_LONG); // Output: '20 de Enero'
 * ```
 */
export const DATE_TEMPLATE_BY_DAY_LONG = 'DD [de] MMMM';

export const DATE_TEMPLATE_BY_MONTH_SHORT = 'DD [de] MMM YYYY';
/**
 * It returns the date template for displaying dates in a long format with day, month, and year.
 *
 * ```javascript
 * import { DATE_TEMPLATE_BY_DAY_LONG_MONTH_YEAR } from 'src/core/constants/date.constants';
 *
 * console.log(DATE_TEMPLATE_BY_DAY_LONG_MONTH_YEAR); // Output: '20 de Enero de 2023'
 * ```
 */
export const DATE_TEMPLATE_BY_DAY_LONG_MONTH_YEAR = 'DD [de] MMMM [de] YYYY';

/**
 * `YYYY-MM-DD` format for backend API requests.
 */
export const DAYJS_ISO_DATE_FORMAT = 'YYYY-MM-DD' as const;

/**
 * `YYYY-MM-DD HH:mm` format for backend API requests.
 */
export const DAYJS_ISO_DATE_TIME_FORMAT = `${DAYJS_ISO_DATE_FORMAT} HH:mm` as const;
